import clsx from 'clsx';
import { useMemo } from 'react';

import { ClientReviewResponse, ProductWidget } from '@vestico/model';

import { Spinner, SpinnerPositioning, SpinnerSize } from '@vestico/shared';

import style from './ProductsList.module.css';
import { ProductListItem } from './ProductsListItem';

export interface ProducstListProps {
  response: ClientReviewResponse | undefined;
  products: ProductWidget[] | null | undefined;
  onProductLinkClick?: (product: ProductWidget) => void;
}
export const ProductsList = ({ response, products, onProductLinkClick }: ProducstListProps) => {
  const items = useMemo(() => {
    if (products === null) {
      return null;
    }
    if (products === undefined) {
      return (
        <div>
          <Spinner positioning={SpinnerPositioning.default} size={SpinnerSize.small} />
        </div>
      );
    }

    const items = products.map((product) => {
      return (
        <ProductListItem
          key={product.documentID}
          response={response}
          product={product}
          hasProduct
          showProductLink
          onProductLinkClick={onProductLinkClick}
        />
      );
    });
    return items;
  }, [onProductLinkClick, products, response]);

  if (!items || !response || response.products.length === 0) {
    return null;
  }

  return <div className={clsx(style.root)}>{items}</div>;
};
